import { TICKER_NEWS } from "@/mocks/home";

export default function Hero() {
  const doubled = [...TICKER_NEWS, ...TICKER_NEWS];
  return (
    <section id="hero" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -top-24 right-0 select-none text-[16rem] leading-none font-black text-primary-500/5 md:text-[24rem]">
        大瓜
      </div>
      <div className="pointer-events-none absolute -bottom-10 left-6 select-none font-display-latin text-[9rem] leading-none text-accent-500/10 md:text-[16rem]">
        NEWS
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pt-32 pb-14 text-center md:px-6 md:pt-44 md:pb-20">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-700">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-600" />
          </span>
          本月大瓜 · 实时追踪中
        </span>

        <h1 className="font-heading mt-6 text-4xl font-black tracking-tight text-foreground-950 sm:text-6xl md:text-7xl">
          本月大瓜
          <span className="ml-3 bg-primary-500 px-2 text-background-50">爆点</span>
          <span className="ml-2 text-accent-600">猛料</span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
          专注聚合本月大瓜爆点与本月大瓜猛料，实时跟进劲爆头条与热门焦点。
          从影视综艺到科技财经，本月大瓜头条与焦点讨论，锁定本页一网打尽。
        </p>

        <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#rank"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-fire-line text-lg" />
            查看实时热榜
          </a>
          <a
            href="#focus"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-950/15 bg-background-100 px-6 py-3 text-sm font-semibold text-foreground-950 transition hover:border-primary-500 hover:text-primary-700"
          >
            <i className="ri-chat-3-line text-lg" />
            围观焦点热议
          </a>
        </div>

        <dl className="mt-12 grid w-full grid-cols-1 gap-3 sm:grid-cols-3">
          {[
            { n: "128", u: "今日更新", d: "条热点动态" },
            { n: "236万", u: "参与热议", d: "本月累计讨论" },
            { n: "1893万", u: "热度峰值", d: "实时全网聚焦" },
          ].map((s, i) => (
            <div
              key={s.u}
              className="flex items-center justify-center gap-4 rounded-2xl border border-background-200 bg-background-100 px-4 py-4"
            >
              <span
                className={`font-display-latin text-3xl md:text-4xl ${
                  i === 2 ? "text-accent-600" : "text-primary-600"
                }`}
              >
                {s.n}
              </span>
              <div className="text-left">
                <dt className="font-heading text-sm font-bold text-foreground-950">{s.u}</dt>
                <dd className="mt-0.5 text-xs text-foreground-600">{s.d}</dd>
              </div>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative border-t border-background-200 bg-background-100 py-3">
        <div className="flex items-center gap-3 overflow-hidden">
          <span className="z-10 flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
            <i className="ri-flashlight-fill" />
            快讯
          </span>
          <div className="relative w-full overflow-hidden">
            <div className="animate-marquee flex w-max items-center gap-10">
              {doubled.map((t, i) => (
                <span key={i} className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-700">
                  <i className="ri-record-circle-fill text-[10px] text-accent-600" />
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}